import { Typography } from "@mui/material";
import { useMemo } from "react";
import Flx from "../../layout/Flx";

const SidebarSectionTitle = ({
  children,
  icon,
  fontSize,
  primary = false,
  subSection = false,
  sx,
}) => {
  const fz = useMemo(() => {
    if (primary) return 18;
    // if (primary) return 16;
    if (fontSize) return fontSize;
    if (subSection) return 11.5;
    return 12.5;
  }, [fontSize, primary, subSection]);
  const fw = useMemo(() => {
    if (primary) return 500;
    // if (primary) return 16;

    if (subSection) return 600;
    return 700;
  }, [primary, subSection]);

  const labelContent = (
    <Typography
      sx={{
        fontSize: fz,
        fontWeight: fw,
        // fontWeight: subSection ? 500 : 700,
        color: "rgb(100, 116, 139)",
        letterSpacing: subSection ? "0.03em" : "0.06em",
        textTransform: subSection || primary ? "none" : "uppercase",
        ...sx,
      }}
    >
      {children}
    </Typography>
  );

  if (icon) {
    return (
      <Flx
        ac
        g={0.5}
        sx={{
          svg: {
            fontSize: `${fz + 3}px !important`,
            color: "rgb(100, 116, 139)",
          },
          ...sx,
        }}
      >
        {icon}
        {labelContent}
        {/* <Typography
            sx={{
              fontSize: fz,
              fontWeight: subSection ? 500 : 700,
              lineHeight: 1,
              color: "rgb(100, 116, 139)",
              letterSpacing: "0.06em",
              ...sx,
            }}
          >
            {children}
          </Typography> */}
      </Flx>
    );
  }

  return labelContent;
};

export default SidebarSectionTitle;
